const defineNostoSlider = () => {
  class ObSliderNosto extends customElements.get("ob-slider") {
    // 'atcListenerInitialised' lives on the class itself
    // Not on individual instances & Shared by all <ob-slider-nosto> elements
    static atcListenerInitialised = false;

    connectedCallback() {
      super.connectedCallback(); // keep the original behavior
      if (!this.matches("[data-nosto-carousel]")) return;

      this.moveEmblaButtons();
      this.enhanceNostoTiles();
      this.initEventListeners();
      this.initGlobalAtcListener();
    }

    initEventListeners() {
      document.addEventListener("click", (e) => {
        const atbBtn = e.target.closest(".add-to-bag-btn");
        if (atbBtn) {
          const nostoItem = atbBtn.closest(".nosto-item");
          if (!nostoItem) return;

          const prodId =
            nostoItem.getAttribute("prodid") || nostoItem.dataset.productId;

          if (!prodId) return;

          const modal = document.querySelector(
            `.qb-modal[prodId="${prodId}"], .qb-modal[data-product-id="${prodId}"]`,
          );

          if (!modal) return;

          document
            .querySelectorAll(".qb-modal.qb-active")
            .forEach((m) => m.classList.remove("qb-active"));

          modal.classList.add("qb-active");

          // Mobile: move modal to body once
          if (window.innerWidth < 1000 && !modal.dataset.teleported) {
            document.body.appendChild(modal);
            modal.dataset.teleported = "true";
          }

          return;
        }

        const closeBtn = e.target.closest(".qb-close, .qb-modal-background");
        if (closeBtn) {
          closeBtn.closest(".qb-modal")?.classList.remove("qb-active");
          return;
        }

        const sizeBtn = e.target.closest(".nosto-size");
        if (sizeBtn) {
          const modal = sizeBtn.closest(".qb-modal");
          if (!modal) return;

          modal
            .querySelectorAll(".nosto-size")
            .forEach((btn) => btn.classList.remove("size-selected"));

          sizeBtn.classList.add("size-selected");

          const sku = sizeBtn.getAttribute("data-variant-id");
          modal.querySelector(".nosto-qb-atc")?.setAttribute("sku", sku);
          return;
        }

        const swatch = e.target.closest(".tile-color-swatch");
        if (swatch) {
          e.preventDefault();

          const modal = swatch.closest(".qb-modal");
          if (!modal) return;

          modal
            .querySelectorAll(".tile-color-swatch")
            .forEach((s) => s.classList.remove("color-selected"));

          swatch.classList.add("color-selected");

          const prodId = swatch.getAttribute("prodId");
          modal.querySelector(".nosto-qb-atc")?.setAttribute("prod", prodId);

          // Filter sizes by product
          modal
            .querySelectorAll(".qb-product-size__button")
            .forEach((btn) => (btn.style.display = "none"));

          modal
            .querySelectorAll(`.qb-product-size__button[prodId='${prodId}']`)
            .forEach((btn) => (btn.style.display = "block"));

          // Update tile image
          const imgURL = swatch.getAttribute("data-imgurl");
          const parentId =
            modal.getAttribute("prodId") || modal.dataset.productId;

          this.querySelector(
            `.nosto-item-${parentId} .main-image`,
          )?.setAttribute("src", imgURL);
          return;
        }
      });

      if (window.innerWidth > 1366) {
        this.querySelectorAll(".nosto-item").forEach((item) => {
          item.addEventListener("mouseleave", () => {
            item
              .querySelector(".nosto-qb-modal.qb-active")
              ?.classList.remove("qb-active");
          });
        });
      }
    }

    initGlobalAtcListener() {
      if (ObSliderNosto.atcListenerInitialised) return;
      ObSliderNosto.atcListenerInitialised = true;

      document.addEventListener("click", async (e) => {
        const modal = e.target.closest(".nosto-qb-modal");
        if (!modal) return;

        const sizeBtn = e.target.closest(".qb-product-size__button");
        const clickedAtcBtn = e.target.closest(".nosto-qb-atc");
        if (!sizeBtn && !clickedAtcBtn) return;

        e.preventDefault()
        e.stopPropagation()

        const atcBtn = clickedAtcBtn || modal.querySelector(".nosto-qb-atc");
        if (!atcBtn) return;

        const skuId = atcBtn.getAttribute("sku");
        const prodId = atcBtn.getAttribute("prod");

        if (!skuId) {
          const originalHtml = atcBtn.innerHTML;
          atcBtn.textContent = "PLEASE SELECT A SIZE";
          atcBtn.style.background = "#595959";
          setTimeout(() => {
            atcBtn.innerHTML = originalHtml;
            atcBtn.style.background = "#000";
          }, 2000);
          return;
        }

        const item = {
          id: parseInt(skuId, 10),
          quantity: 1,
        };

        if (window.privateSale || window.initialPrivateSaleAccess) {
          item.properties = { PrivateSale: "Segmented" };
        }

        try {
          const state = await window.BAO.Cart.addItem(item);

          if (!state) return;

          document
            .querySelectorAll(".qb-modal.qb-active")
            .forEach((m) => m.classList.remove("qb-active"));

          const attributionKey = modal.closest("[data-nosto-carousel]")?.dataset
            .nostoAttribution;

          if (window.nostojs && prodId) {
            window.nostojs((api) => {
              api.recommendedProductAddedToCart(prodId, attributionKey);
            });
          }

          if (
            typeof publish !== "undefined" &&
            typeof PUB_SUB_EVENTS !== "undefined"
          ) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: skuId,
              cartData: state,
            });
          } else if (window.publish) {
            window.publish("cart-update", { cartData: state });
          }

          if (window.Nosto?.reloadCart) {
            window.Nosto.reloadCart();
          }
        } catch (err) {
          console.error("ATC error:", err);
        }
      });
    }

    moveEmblaButtons() {
      const slider = this.querySelector(".ob-slider");
      if (!slider) return;

      const emblaRoot =
        slider.shadowRoot?.querySelector(".embla") ||
        slider.querySelector(".embla");

      if (!emblaRoot) return;

      const buttonsWrapper =
        slider.shadowRoot?.querySelector(".embla-buttons") ||
        slider.querySelector(".embla-buttons");

      if (!buttonsWrapper) return;

      const prev = buttonsWrapper.querySelector(".embla-button--prev");
      const next = buttonsWrapper.querySelector(".embla-button--next");

      if (!prev || !next) return;

      // Create containers if you want styling hooks
      const prevWrap = document.createElement("div");
      prevWrap.className = "nosto-arrow nosto-arrow--prev";

      const nextWrap = document.createElement("div");
      nextWrap.className = "nosto-arrow nosto-arrow--next";

      prevWrap.appendChild(prev);
      nextWrap.appendChild(next);

      // Insert arrows as siblings of the slider
      slider.parentNode.insertBefore(prevWrap, slider);
      slider.parentNode.insertBefore(nextWrap, slider.nextSibling);

      // Remove empty wrapper
      buttonsWrapper.remove();
    }

    enhanceNostoTiles() {
      const SHOPIFY_STORE_URL =
        "https://orlebarbrown.myshopify.com/api/2024-01/graphql.json";
      const ACCESS_TOKEN = "72ed9195cba4e7716b65f179c960dc39";

      this.querySelectorAll(".ob-slider .ob-slide").forEach((tile) => {
        const prodId = tile.getAttribute("prodID");

        const graphQuery = `
        {
          product(id: "gid://shopify/Product/${prodId}") {
            badge: metafield(namespace: "custom", key: "product_badge"){
              reference {
                ... on Metaobject {
                  fields { value }
                }
              }
            }
            related: metafield(namespace: "custom", key: "product_related_sku") {
              references(first: 25) {
                edges {
                  node {
                    ... on Product {
                      id
                      handle
                      availableForSale
                      featuredImage {
                        url
                      }
                      variants(first: 25) {
                        edges {
                          node {
                            id
                            availableForSale
                            title
                          }
                        }
                      }
                      color: metafield(namespace: "custom", key: "product_primary_color") {
                        value
                      }
                      swatchImg: metafield(namespace: "custom", key: "product_swatch_image") {
                        value
                      }
                      customId: metafield(namespace: "custom", key: "material_code") {
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `;

        fetch(SHOPIFY_STORE_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": ACCESS_TOKEN,
          },
          body: JSON.stringify({ query: graphQuery }),
        })
          .then((res) => res.json())
          .then((res) => {
            const badge = res?.data?.product?.badge?.reference?.fields;
            const related = res?.data?.product?.related?.references?.edges;

            if (badge && badge.length) {
              const badgeNode = tile.querySelector(".nosto-badge span");
              if (badgeNode) {
                badgeNode.textContent = badge[1]?.value ?? "";
                badgeNode.style.color = badge[0]?.value ?? "#000";
                badgeNode.style.display = "block";
              }
            }

            // if (related?.length > 0) {
            //   const swatchContainer = tile.querySelector(".product-color-swatches");
            //   related.slice(0, 3).forEach((prod) => {
            //     const node = prod.node;
            //     const swatch = document.createElement("a");
            //     swatch.className = "product-item tile-color-swatch";
            //     swatch.href = `/products/${node.handle}`;
            //     swatch.setAttribute("prodId", node.id.split("/").pop());
            //     swatch.setAttribute("data-id", node.customId?.value ?? "");
            //     swatch.setAttribute("available", node.availableForSale);
            //     swatch.innerHTML = `<img loading="lazy" src="${node.swatchImg?.value ?? ""}" alt="${node.handle}" />`;
            //     swatchContainer?.appendChild(swatch);
            //   });

            //   if (related.length > 3) {
            //     const more = document.createElement("div");
            //     more.className = "product-item-more";
            //     more.innerHTML = `<div class="product-more_link" tabindex="0">+${related.length - 3}</div>`;
            //     swatchContainer?.appendChild(more);
            //   }
            // }
          })
          .catch(console.error);
      });
    }
  }
  customElements.define("ob-slider-nosto", ObSliderNosto);
};

if (customElements.get("ob-slider")) {
  defineNostoSlider();
} else {
  customElements.whenDefined("ob-slider").then(defineNostoSlider);
}
